import { toast } from "sonner";
import { MessageCircle, Mail, Trash2 } from "lucide-react";
import { gmailCompose } from "../../lib/gmail";

const STATUSES = { nuevo: "Nueva", contactado: "Contactado", cerrado: "Cerrada" };

function whatsappUrl(phone, name) {
  const digits = (phone || "").replace(/[^\d]/g, "").replace(/^00/, "");
  const text = `Hola ${name}, soy de Maggie Records. Te escribo por los discos que nos ofreces.`;
  return digits.length >= 8 ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : null;
}

export default function AdminSellRequests({ data, client, onChanged }) {
  if (!data) return <p className="text-sm text-muted-foreground">Cargando…</p>;

  const setStatus = async (id, status) => {
    try {
      await client.put(`/admin/sell-requests/${id}`, { status });
      await onChanged();
    } catch {
      toast.error("No se pudo actualizar");
    }
  };
  const remove = async (id) => {
    if (!window.confirm("¿Borrar esta oferta?")) return;
    try {
      await client.delete(`/admin/sell-requests/${id}`);
      await onChanged();
    } catch {
      toast.error("No se pudo borrar");
    }
  };

  return (
    <div data-testid="admin-sell-tab">
      <div className="mb-6 border-b border-border pb-4">
        <h2 className="text-2xl">Compramos tus discos</h2>
        <p className="text-sm text-muted-foreground mt-1">Ofertas de colecciones recibidas desde la web ({data.count}).</p>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-muted-foreground">Aún no hay ofertas.</p>
      ) : (
        <div className="space-y-3">
          {data.items.map((r) => {
            const wa = whatsappUrl(r.phone, r.name);
            return (
              <div key={r.id} className="border border-border p-5" data-testid={`sell-${r.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                  <div className="text-sm">
                    <strong>{r.name}</strong>{" "}
                    <span className="text-muted-foreground text-xs">{new Date(r.created_at).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" })}</span>
                    <div className="text-xs text-muted-foreground mt-1">
                      {[r.email, r.phone, r.location, r.quantity && `${r.quantity} discos`, r.genres].filter(Boolean).join(" · ")}
                    </div>
                  </div>
                  <select value={r.status} onChange={(e) => setStatus(r.id, e.target.value)} className="bg-transparent border border-border px-2 py-1 text-xs">
                    {Object.entries(STATUSES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                  </select>
                </div>
                <p className="text-sm whitespace-pre-line bg-[hsl(var(--muted))] p-3">{r.message}</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {wa && (
                    <a href={wa} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 bg-foreground text-background px-3 py-1.5 vmr-tiny">
                      <MessageCircle size={12} /> WhatsApp
                    </a>
                  )}
                  <a href={gmailCompose({ to: r.email, subject: "Tus discos · Maggie Records" })} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 border border-foreground px-3 py-1.5 vmr-tiny">
                    <Mail size={12} /> Email
                  </a>
                  <button onClick={() => remove(r.id)} className="inline-flex items-center gap-1.5 border border-border px-3 py-1.5 vmr-tiny text-muted-foreground hover:text-foreground ml-auto">
                    <Trash2 size={12} /> Borrar
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
